import *as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AssociatedWorkkard_ORGANIZATIONID_ARRAY, AssociatedWorkkard_ORGANIZATIONION_FILTER_ARRAY, RightPanelConstant } from '../../../containers/WorkkardDetail/constants';
import { showDialogueBox } from '../../../components/DialogueBox/actions';
import { fetchAssociatedWorkkardRequest, selectAssociatedWorkkard, selectAssociatedWorkkardFilter } from '../slice';
import AssociatedWorkkardComponent from '../../../components/AssociatedWorkkard';
import {getUserInfo } from '../../SpockViewPage/actions/action';
import { useModules } from '../../../utils/modules';

function AssociatedWorkkard(props) {
    const { isModuleEnabled } = useModules();
    const showAssociatedWorkkardWidget =
        isModuleEnabled("workkards.associated_workkard.matching_criteria_policy_number_will_not")
        || isModuleEnabled("workkards.associated_workkard.filters");
    const dispatch = useDispatch();
    const workkard = useSelector(state => state.workkardDetail.workkardDetail);
    const OrganizationView = useSelector(state => state.sessionContextOidc.organizationView);
    const organizationLoaded = useSelector(state => state.sessionContextOidc.organizationLoaded);
    const associatedWorkkard = useSelector(selectAssociatedWorkkard);
    const associatedWorkkardFilter = useSelector(selectAssociatedWorkkardFilter);
    const IsAuditUser = useSelector(state => state.sessionContextOidc.isAuditUser);

    const orgsArr = useRef("");
    const orgObjArr = useRef([]);

    const [showAssociatedwkByOrg, setShowAssociatedwkByOrg] = useState(false);
    const [isloadedAssociatedWk, setIsloadedAssociatedWk] = useState(false);

    function isShowAwWithOrg() {
        
        if (!IsAuditUser) {
            const OrganizationIds = AssociatedWorkkard_ORGANIZATIONID_ARRAY;
            const hasMatch = OrganizationIds.some((element) => OrganizationView?.Id == element);

            if (hasMatch) {
                getAwOrgsForGivenOrgType();
                return true;
            }
        }

        return false;
    }

    function getAwOrgsForGivenOrgType() {
        let orgArray = AssociatedWorkkard_ORGANIZATIONION_FILTER_ARRAY;
        orgArray.map((element) => {
            if (element.hasOwnProperty(OrganizationView.Id)) {
                orgObjArr.current = element[OrganizationView.Id];
                orgsArr.current = element[OrganizationView.Id].map((item) => { return item.OrgId }).join(",");
            }
        });
    }

    const prevWkId = useRef(null);
    useEffect(() => {
        if (props.wkId && !isloadedAssociatedWk && workkard.AssociatedWorkkardCount !== 0 && organizationLoaded) {
            var result = isShowAwWithOrg();
            setShowAssociatedwkByOrg(result);
            setIsloadedAssociatedWk(true);
            dispatch(fetchAssociatedWorkkardRequest({
                selectedFilter: 'Property Location',
                tmplType: 'HCI',
                wkId: props.wkId,
                orgids: result == true ? orgsArr.current : null
            }));
        }

        if (props.showAssociatedWorkkardDetail && props.wkId && showAssociatedWorkkardWidget) {
            showModelPopUp();
        }
    }, [props.wkId, props.showAssociatedWorkkardDetail, organizationLoaded, showAssociatedWorkkardWidget]);

    function onFilterChange(payload) {
        dispatch(fetchAssociatedWorkkardRequest({ ...payload, clearAssociatedWorkkard: true }));
    }

    function onOrgFilterChange(payload) {
        dispatch(fetchAssociatedWorkkardRequest({ ...payload, clearAssociatedWorkkard: true }));
    }

    function onScroll(payload) {
        dispatch(fetchAssociatedWorkkardRequest(payload));
    }

    function showUserInfo(payload) {
        dispatch(getUserInfo(payload));
    }

    function closeDialogBox() {
        dispatch(showDialogueBox({
            flag: false,
            dialogueBoxComponent: null,
        }));
        props.closeAssociatedWorkkardDetailPopUp();
    }

    /** fill the dialog  box  with  associated workkard  data  */
    function showModelPopUp() {
        dispatch(showDialogueBox({
            flag: true,
            component: <AssociatedWorkkardComponent
                wkId={props.wkId}
                showAwWithOrg={showAssociatedwkByOrg}
                orgFilterArray={orgsArr.current}
                ogFilterObjArray={orgObjArr.current}
                onClose={closeDialogBox}
                onAssociatedWorkkardFilterChange={onFilterChange}
                onAssociatedWorkkardOrgFilterChange={onOrgFilterChange}
                onAssociatedWorkkardScroll={onScroll}
                showUserInfo={showUserInfo}
            />,
            overlayClassName: "modal animated faster fadeIn",
            contentClassName: "modalContent animated faster fadeInUpx2 large",
            shouldCloseOnOverlayClick: true
        }));
    }

    return showAssociatedWorkkardWidget && (
        <div className={`associatedWorkkard animated faster ${props.class}`}>
            <header className="alignMiddle">
                <h3 onClick={showModelPopUp}>
                    <div className="rowSpaceBetween alignMiddle">
                        <span className="mr__4 flexGrow"> {RightPanelConstant.AssociatedWorkkardsText} ({associatedWorkkard.total || 0})</span>
                        <a href="javascript:void(0)" onClick={showModelPopUp} className="viewAll viewLink ml">
                            {associatedWorkkard && associatedWorkkard.data && associatedWorkkard.data.length >= 0 && RightPanelConstant.ViewAllText}
                        </a>
                    </div>
                    {associatedWorkkardFilter.filter && isModuleEnabled("workkards.associated_workkard.matching_criteria_policy_number_will_not") && <label className="mt_0">matching {associatedWorkkardFilter.filter[0]}</label>}
                </h3>
            </header>
        </div>
    );
}

export default AssociatedWorkkard;